<template>
	<div class="container">
		<div ref="menu" class="scroll menu" :isMobile="_isMobile"
			:style="{ 'height': (_height - (_isMobile ? 180 : 160)) + 'px' }">
			<ul class="components">
				<li v-for="(menu, index) in menus" v-show="(menu.privilegio != 0 ? _getPrivilegio(menu.privilegio) : true)"
					:key="index">

					<!-- MENU SEM SUB MENU -->
					<div v-if="menu.submenu.length == 0" @click="$emit('exibe-menu', _isMobile ? false : true, '')">
						<router-link :class="menu.class" :to="{ name: menu.routerName }">
							<span v-if="menu.faIcon" :style="menu.styleIcon">
								<fa-icon :icon="menu.faIcon" />
							</span>

							<fl-icon v-if="menu.flIcon" :style="menu.styleIcon" :name="menu.flIcon" />
							{{ menu.text }}
						</router-link>
					</div>


					<!-- CASO O MENU TENHA SUB MENU -->
					<div v-if="menu.submenu.length > 0" :class="{ 'bk-sub': menu.exibeSub }">
						<div id="cont">
							<!-- LINK PARA ABRIR O SUBMENU -->
							<div id="sub-menu" @click.prevent.stop="clickExibeSub(index)">
								<span v-if="menu.faIcon" :style="menu.styleIcon">
									<fa-icon :icon="menu.faIcon" />
								</span>
								<fl-icon v-if="menu.flIcon" :style="menu.styleIcon" :name="menu.flIcon" />
								{{ menu.text }}
								<fa-icon class="float-right"
									:class="{ 'animate-sub-in': menu.exibeSub, 'animate-sub-out': !menu.exibeSub }"
									style="margin-top:0.3em; margin-right:1em" icon="angle-left" />
							</div>

							<!-- LISTA DE SUB MENUS -->
							<ul class="components" :class="{ 'animated fadeInLeft faster': menu.exibeSub }"
								style="margin-left: 0em" v-if="menu.exibeSub">
								<li v-for="(subMenu, index) in menu.submenu"
									@click="$emit('exibe-menu', _isMobile ? false : true, menu)" :key="index">

									<router-link :class="subMenu.class"
										v-if="(subMenu.privilegio != 0 ? _getPrivilegio(subMenu.privilegio) : true)"
										:to="{ name: subMenu.routerName }">
										<span v-if="subMenu.faIcon" :style="subMenu.styleIcon">
											<fa-icon :icon="subMenu.faIcon" />
										</span>

										<fl-icon v-if="subMenu.flIcon" :style="subMenu.styleIcon" :name="subMenu.flIcon" />
										{{ subMenu.text }}
									</router-link>
								</li>
							</ul>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import flIcon from '../../components/fl-icon/main.vue'
export default {

	components: {
		flIcon,
	},

	props: ['menus'],


	methods: {
		clickExibeSub(index) {

			this.menus[index].exibeSub = !this.menus[index].exibeSub

			if(this.menus[index].exibeSub)
			{
				document.getElementById("cont").style["marginTop"] = '10px';
			}

			else
			{
				document.getElementById("cont").style["marginTop"] = '0px';
			}

			this.$nextTick(() => {
				this.$refs.menu.scrollTop = this.$refs.menu.scrollHeight;
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.scroll::-webkit-scrollbar {
	width: 6px;
	background-color: #31343E;
}

.scroll::-webkit-scrollbar-thumb {
	background-color: silver;
	border-radius: 3px;
}

.container {
	font-family: poppins, sans-serif;
	font-size: 0.88rem;
	background: var(--color-background);
	user-select: none;
	overflow-x: auto;
	color: var(--color-dark);
	height: 70vh;
}

.menu {
	display: grid;
	width: 96%;
	margin: 0 auto;
	gap: 1.8rem;
	grid-template-columns: 14rem auto 23rem;
	height: 100vh;
}

.router-link-active {
	background-color: var(--color-light);
	color: var(--color-primary);
	margin-left: 0;
	font-size: 1rem;
	cursor: pointer;
}

.router-link-active span {
	color: var(--color-primary);
	margin-left: calc(1rem - 3px);
	font-size: 1rem;
}

ul.components {
	list-style-type: none;
	padding: 25px 5px 50px 5px;
	margin: -15px 5px 5px 5px;

}

ul.components li {
	display: flex;
	color: var(--color-dark);
	margin-left: 0;
	gap: 1rem;
	align-items: center;
	height: 3.7rem;
	transition: all 300ms ease;
	font-size: 0.88rem;
}

ul.components li:hover {
	cursor: pointer;
}


ul li a {
	font-size: 0.87rem;
	font-weight: 500;
}

ul li a span {
	font-size: 0.88rem;
	transition: all 300ms ease;
}

ul li a:hover {
	color: var(--color-primary);
	cursor: pointer;
}

ul li a span:hover {
	cursor: pointer;
}

ul li a:hover span {
	margin-left: 1rem;
}

.bk-sub {
	//background:conic-gradient(#d95641, #b14439, #b2453a,#d25645,#d95641, #b14439, #b2453a,#d25645,#d95641, #b14439, #b2453a,#d25645,#d95641, #b14439, #b2453a,#d25645);
	color: var(--color-primary);
	background: var(--color-background);
	width:$widthBar;
	z-index: 1;
}

#sub-menu {
	overflow: hidden;
	z-index: 2;
	font-size: 0.87rem;
	font-weight: 500;
}

#sub-menu span {
	font-size: 0.88rem;
	transition: all 300ms ease;
	z-index: 2;
	cursor: pointer;
}

#sub-menu:hover {
	color: var(--color-primary);
}

#sub-menu:hover span {
	margin-left: 1rem;
}

.animate-sub-in {
	transform: rotate(-90deg);
	animation-name: animateSubIn;
	animation-duration: 0.5s;

	@keyframes animateSubIn {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(-90deg);
		}
	}
}

.animate-sub-out {
	transform: rotate(0deg);
	animation-name: animateSubOut;
	animation-duration: 0.5s;

	@keyframes animateSubOut {
		0% {
			transform: rotate(-90deg);
		}

		100% {
			transform: rotate(0deg);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/menu/menu.vue